// extracted by mini-css-extract-plugin
export default {"teamItem":"TeamListSite_teamItem__JVbLu","title":"TeamListSite_title__dVBHa"};